export class CardTableAction {
	iconName?: string;
	iconSrc?: string;
	title: string;
	color: string;
	showIcon?: boolean;
	display?: boolean;
}
